<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="text-h6">{{ isEditMode ? 'Edit Employee Loan' : 'Add Employee Loan' }}</v-card-title>
            <v-card-text class="pa-3">
              <v-form @submit.prevent="submit">
                <v-row class="pa-2" dense>
                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-autocomplete
                      variant="outlined"
                      density="compact"
                      
                      v-model="employee_id.value.value"
                      :items="getHrmEmployeeList"
                      :item-title="(item) => `${item.name} - ${item.code || item.employee_code || ''}`"
                      item-value="id"
                      :error-messages="employee_id.errorMessage.value"
                      label="Employee"
                      clearable
                      :loading="loading"
                      no-data-text="No employees found"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                      <template #label>
                        Employee <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-text-field
                      variant="outlined"
                        density="compact"
                        
                      v-model="loan_amount.value.value"
                      type="number"
                      min="1"
                      step="0.01"
                      :error-messages="loan_amount.errorMessage.value"
                      label="Loan Amount"
                    >
                      <template #label>
                        Loan Amount <span class="text-red-accent-4">*</span>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-text-field
                      variant="outlined"
                      density="compact"
                      
                      v-model="installments.value.value"
                      type="number"
                      min="1"
                      :error-messages="installments.errorMessage.value"
                      label="Number of Installments"
                    >
                      <template #label>
                        Installments <span class="text-red-accent-4">*</span>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="issue_date.value.value"
                      label="Issue Date"
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="compact"
                      prepend-icon=""
                      
                      clearable
                      :error-messages="issue_date.errorMessage.value"
                    >
                      <template #label>
                        Issue Date <span class="text-red-accent-4">*</span>
                      </template>
                    </v-date-input>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      
                      v-model="refund_start_date.value.value"
                      label="Refund Start Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="compact"
                      
                      clearable
                      :error-messages="refund_start_date.errorMessage.value"
                    >
                      <template #label>
                        Refund Start Date <span class="text-red-accent-4">*</span>
                      </template>
                    </v-date-input>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-autocomplete
                      variant="outlined"
                      density="compact"
                      
                      v-model="payment_method.value.value"
                      :items="paymentMethodList"
                      item-title="title"
                      item-value="value"
                      :error-messages="payment_method.errorMessage.value"
                      label="Payment Method"
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                      <template #label>
                        Payment Method <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6" lg="4" class="py-0">
                    <v-autocomplete
                      v-if="payment_method.value.value"
                      variant="outlined"
                      density="compact"
                      
                      v-model="payment_account_head_id.value.value"
                      :items="accountHeads"
                      item-title="name"
                      item-value="id"
                      :error-messages="payment_account_head_id.errorMessage.value"
                      label="Payment Account Head"
                      :loading="paymentAccountHeadLoading"
                      clearable
                    
                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                      <template #label>
                        Payment Account Head <span class="text-red-accent-4">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <template v-if="payment_method.value.value === 'BANK'">
                    <v-col cols="12" md="6" lg="4" class="py-0">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                     
                        v-model="cheque_no.value.value"
                        :error-messages="cheque_no.errorMessage.value"
                        label="Cheque No"
                      >
                        <template #label>
                          Cheque No <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" lg="4" class="py-0">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="cheque_date.value.value"
                        label="Cheque Date"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        density="compact"
                       
                        clearable
                        :error-messages="cheque_date.errorMessage.value"
                      >
                        <template #label>
                          Cheque Date <span class="text-red-accent-4">*</span>
                        </template>
                      </v-date-input>
                    </v-col>
                  </template>

                  <v-col cols="12" class="py-0">
                    <v-textarea
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="remarks.value.value"
                      :error-messages="remarks.errorMessage.value"
                      label="Remarks"
                      rows="4"
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" class="py-0 pt-1 d-flex justify-end align-center">
                    <v-checkbox
                      v-model="status.value.value"
                      label="Active"
                      color="primary"
                      density="compact"
                      hide-details
                      :true-value="1"
                      :false-value="0"
                    />
                  </v-col>
                </v-row>

                <v-card-actions>
                  <v-spacer />
                  <v-btn variant="outlined" @click="router.push({ name: 'loan-records' })">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    variant="flat"
                    type="submit"
                    :loading="submitting"
                  >
                    {{ isEditMode ? 'Update Loan' : 'Save Loan' }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useField, useForm } from "vee-validate";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import * as yup from "yup";
import { formatDateDash } from "@/plugins/helpers";

export default {
  name: "AddEmployeeLoan",

  data: () => ({
    accountHeads: [],
    paymentAccountHeadLoading: false,
    paymentMethodList: [
      { title: "Cash", value: "CASH" },
      { title: "Bank", value: "BANK" },
    ],
  }),

  watch: {
    "payment_method.value.value"(val) {
      if (!val) {
        this.accountHeads = [];
        return;
      }
      this.paymentAccountHeadLoading = true;
      this.$store
        .dispatch("getPaymentAccountHeads", { payment_method: val })
        .then((res) => {
          this.accountHeads = res.data || [];
        })
        .finally(() => {
          this.paymentAccountHeadLoading = false;
        });
    },
  },

  created() {
    // if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.$store.dispatch("getHrmEmployeeList");
    // }
  },

  computed: {
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList || [];
    },
    isEditMode() {
      return this.$route.name === "edit-loan" && !!this.$route.params.id;
    },
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const submitting = ref(false);
    const loading = ref(false);

    const validationSchema = yup.object({
      employee_id: yup.number().required().label("Employee"),
      loan_amount: yup.number().positive().required().label("Loan Amount"),
      installments: yup.number().positive().integer().required().label("Installments"),
      issue_date: yup.date().required().label("Issue Date"),
      refund_start_date: yup.date().required().label("Refund Start Date"),
      payment_method: yup.string().oneOf(["CASH", "BANK"]).required().label("Payment Method"),
      payment_account_head_id: yup.number().required().label("Payment Account Head"),
      cheque_no: yup.string().when("payment_method", {
        is: "BANK",
        then: (s) => s.required().label("Cheque No"),
        otherwise: (s) => s.nullable(),
      }),
      cheque_date: yup.date().when("payment_method", {
        is: "BANK",
        then: (s) => s.required().label("Cheque Date"),
        otherwise: (s) => s.nullable(),
      }),
      status: yup.number().oneOf([0, 1]).required().label("Status"),
      remarks: yup.string().nullable().max(255).label("Remarks"),
    });

    const { handleSubmit } = useForm({
      validationSchema,
      initialValues: { status: 1 },
    });

    const employee_id = useField("employee_id");
    const loan_amount = useField("loan_amount");
    const installments = useField("installments");
    const issue_date = useField("issue_date");
    const refund_start_date = useField("refund_start_date");
    const payment_method = useField("payment_method");
    const payment_account_head_id = useField("payment_account_head_id");
    const cheque_no = useField("cheque_no");
    const cheque_date = useField("cheque_date");
    const status = useField("status");
    const remarks = useField("remarks");

    const loadLoanForEdit = async () => {
      const id = route.params.id;
      if (!id) return;
      loading.value = true;
      try {
        const loan = await store.dispatch("getEmployeeLoanById", id);
        if (loan) {
          employee_id.value.value = loan.employee_id;
          loan_amount.value.value = loan.loan_amount;
          installments.value.value = loan.total_installments;
          issue_date.value.value = loan.issue_date ? new Date(loan.issue_date) : null;
          refund_start_date.value.value = loan.refund_start_date ? new Date(loan.refund_start_date) : null;
          status.value.value = loan.status ?? 1;
          remarks.value.value = loan.remarks || null;
          if (loan.voucher) {
            payment_method.value.value = loan.voucher.payment_method || "CASH";
            payment_account_head_id.value.value = loan.voucher.payment_acc_account_head_id || null;
            cheque_no.value.value = loan.voucher.cheque_no || null;
            cheque_date.value.value = loan.voucher.cheque_date ? new Date(loan.voucher.cheque_date) : null;
          }
        }
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load loan.");
        router.push({ name: "loan-records" });
      } finally {
        loading.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      submitting.value = true;

      const payload = {
        employee_id: values.employee_id,
        loan_amount: parseFloat(values.loan_amount),
        installments: parseInt(values.installments),
        issue_date: formatDateDash(values.issue_date),
        refund_start_date: formatDateDash(values.refund_start_date),
        payment_method: values.payment_method,
        payment_account_head_id: values.payment_account_head_id,
        status: values.status,
        remarks: values.remarks || null,
      };

      if (values.payment_method === "BANK") {
        payload.cheque_no = values.cheque_no;
        payload.cheque_date = formatDateDash(values.cheque_date);
      }

      try {
        const id = route.params.id;
        if (id) {
          await store.dispatch("updateEmployeeLoan", { id, data: payload });
          toast.success("Loan updated successfully.");
        } else {
          await store.dispatch("storeEmployeeLoan", payload);
          toast.success("Loan created successfully.");
        }
        router.push({ name: "loan-records" });
      } catch (err) {
        const msg = err.response?.data?.message || "Failed to save loan.";
        toast.error(msg);
      } finally {
        submitting.value = false;
      }
    });

    return {
      employee_id,
      loan_amount,
      installments,
      issue_date,
      refund_start_date,
      payment_method,
      payment_account_head_id,
      cheque_no,
      cheque_date,
      status,
      remarks,
      submit,
      submitting,
      loading,
      router,
      loadLoanForEdit,
    };
  },

  mounted() {
    if (this.isEditMode) {
      this.loadLoanForEdit();
    }
  },
};
</script>
